import {Component, Input} from '@angular/core';
import {UntypedFormGroup} from "@angular/forms";
import {otherORCounties, topORCounties} from "../../../../util/counties";

@Component({
  selector: 'app-county-oregon-select',
  templateUrl: './county-oregon-select.component.html',
  styleUrls: ['./county-oregon-select.component.scss']
})
export class CountyOregonSelectComponent {
  @Input() parentForm: UntypedFormGroup;
  @Input() formCtrlName: string;
  @Input() change;

  public readonly topORCounties = topORCounties;
  public readonly otherORCounties = otherORCounties;
}
